import * as Yup from "yup";

export const LoginSchema = Yup.object({

    email: Yup.string().required("Email is Required"),
    password: Yup.string().required("Enter Your Password"),
});